const ProductFeedback = {

    productFeedbackSelector: "",

    init: function (productFeedbackSelector) {
        this.productFeedbackSelector = productFeedbackSelector;
        $(document).on('change', 'input[name="IsAnswerRequired"]', this.toggleContactData);
    },

    sendFeedback: function (urlSend, formSelector) {
        $.ajax({
            cache: false,
            url: urlSend,
            data: $(formSelector).serialize(),
            type: 'post',
            success: this.success_process.bind(this),
            error: this.ajaxFailure
        });
    },

    success_process: function (response) {
        if (response.html) {
            $(this.productFeedbackSelector).html(response.html);
        }
    },

    ajaxFailure: function () {
        alert('Failed to send feedback. Please refresh the page and try one more time.');
    },

    toggleContactData: function () {
        const wantsAnswer = $('input[name="IsAnswerRequired"]:checked').val() === 'true';
        const group = $('#contact-data-group');
        group.toggleClass('d-none', !wantsAnswer);
        if (!wantsAnswer) {
            group.find('input').val('');
        }
    }
};

window.addEventListener('DOMContentLoaded', function () {
    ProductFeedback.init("#product-feedback");
});

window.ProductFeedback = ProductFeedback;
